module.exports = __webpack_public_path__ + "img/demo.865eae17.png";